import { TOKEN_IDomThemes } from '@/services/DomThemes';
import type { IDomThemes, ThemeMode } from '@/services/DomThemes';
import { TOKEN_IProjectBus, type IProjectBus } from '@/services/ProjectBus';
import { makeAutoObservable } from 'mobx';
import { inject, injectable } from 'tsyringe';

export const TOKEN_ThemeStore = Symbol("ThemeStore");

@injectable()
export default class ThemeStore {
    currentTheme: ThemeMode = 'system';
    isDarkMode: boolean = false;

    constructor(
        @inject(TOKEN_IDomThemes) private domThemes: IDomThemes,
        @inject(TOKEN_IProjectBus) private projectBus: IProjectBus
    ) {
        makeAutoObservable(this);

        // Initialize current values
        this.currentTheme = this.domThemes.getCurrentTheme();
        this.isDarkMode = this.domThemes.isDarkMode();

        // Subscribe to theme change events
        this.projectBus.subscribe_themeChanged(async (data) => {
            this.currentTheme = data.theme;
            this.isDarkMode = data.isDarkMode;
        });
    }

    setTheme = (theme: ThemeMode) => {
        this.domThemes.setTheme(theme);
    };

    toggleTheme = () => {
        this.domThemes.toggleTheme();
    };
}